<template>
	<div class="following">
		<ModalFollowSearch
			:modal-name="modalNameFollowSearch"
		/>
		<LoadingSpinner
			v-if="isLoadingFollowing"
			class="following__loading-spinner"
		/>
		<template v-else>
			<div class="following__section">
				<div class="following__header">
					<SectionTitle
						type="md"
						title="Following"
						:vertical-spacing="false"
					/>
					<Button
						:text="$I18n.trans('arena.fan_account.following.follow_favorites')"
						:theme="$arenaConfig.isLightTheme ? null : 'dark'"
						icon="e-add"
						@click="openFollowSearchModal"
					/>
				</div>
				<div
					v-if="follows.length > 0"
					class="following__list"
				>
					<div
						v-for="item in follows"
						:key="`${item.context.id}-${item.contextable.id}`"
						class="following__item"
					>
						<div class="following__item-name">
							<img
								:src="$Helpers.getScaledImageUrl(item.contextable.imageUrl, 48, { heightIsWidth: true })"
								:alt="item.contextable.name"
								class="following__item-image"
							>
							{{ item.contextable.name }}
						</div>
						<FollowButton
							:dark-theme="$arenaConfig.isLightTheme ? false : true"
							:followable="item"
							:is-following="true"
							:is-following-in-progress="item.isFollowingInProgress"
							:is-locked="item.locked"
						/>
					</div>
				</div>
				<FollowingEmptyState
					v-else
					@open-follow="openFollowSearchModal"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import LoadingSpinner from '@shared/components/LoadingSpinner';
import SectionTitle from '@js/components/SectionTitle';
import ModalFollowSearch from '@js/Pages/FanAccount/ModalFollowSearch';
import FollowingEmptyState from '@js/Pages/FanAccount/partials/FollowingEmptyState';
import Button from '@shared/components/Button';
import FollowButton from '@js/Pages/FanAccount/partials/FollowButton';
import { mapGetters, mapActions } from 'vuex';
import { actions } from '@shared/js/store/modules/following';
import storage from '@shared/js/storage';

export default {
	name:       'Settings',
	components: { LoadingSpinner, SectionTitle, ModalFollowSearch, Button, FollowingEmptyState, FollowButton },
	data() {
		return {
			isProcessing:          false,
			modalNameFollowSearch: 'followSearchModal',
		};
	},
	computed: {
		...mapGetters({
			follows:            'following/follows',
			isLoadingFollowing: 'following/isLoading',
		}),
	},
	mounted() {
		this.loadFollowing();
	},
	methods: {
		...mapActions({
			loadFollowing:   `following/${actions.LOAD_FOLLOWS}`,
			loadFollowables: `following/${actions.LOAD_FOLLOWABLES}`,
			unfollow:        `following/${actions.UNFOLLOW}`,
		}),
		openFollowSearchModal() {
			this.eventBus.$emit(`modal:${this.modalNameFollowSearch}`);
		},
		handleUnfollow(item) {
			this.unfollow(item);
			storage.setCacheTs();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.following__header {
	display: none;

	@include size(md-up) {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: $sp6;
	}
}

.following__item {
	@include font-size(fs-80);
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: $sp3-5 0;
	border-bottom: 1px solid var(--color-grey-900);
}

.following__item-image {
	width: 24px;
	margin-right: $sp2;
}
</style>
